import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

// 🔴 RELATIVE TIME ONLY — NO "Today," PREFIX (George, 22 September 2026: "for fromNow() dont
// put today, just 20 minutes ago, etc."). `isToday()` was being used to prepend the word
// "Today" and `isYesterday()` to swap in an absolute "Yesterday at 4:32 PM", so the saved
// list mixed three formats. Every row is now the one relative reading dayjs gives.
// `dateFormatted`, `timeFormatted` and their three plugins went with them — nothing used them.
export const friendlyDateFormat = date => (date ? dayjs(date).fromNow() : '-')
